import BackendService from 'BackendService';
import { GlobalConfiguration } from '../../models/GlobalConfiguration';

class GlobalConfigurationCache {
  private config: GlobalConfiguration | null = null;

  /**
   * Returns the cached config or fetches it from the backend if missing.
   */
  async getConfig(): Promise<GlobalConfiguration> {
    return new BackendService().getGlobalConfiguration();
  }

  setConfig(cfg: GlobalConfiguration) {
    this.config = cfg;
  }

  /**
   * Forces the next `getConfig()` to re-fetch from the backend.
   */
  clearCache(): void {
    this.config = null;
  }
}

const globalConfigurationCache = new GlobalConfigurationCache();
export { globalConfigurationCache };
